import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@arco-design/web-react';

/** 物理节点 RadioList 列配置（含节点引导网固定 IPv4） */
export function useNodeListColumns() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        title: t('common:node.name'),
        dataIndex: 'metadata.name',
        fixed: 'left' as const,
      },
      {
        title: t('common:architecture'),
        dataIndex: 'spec.architecture',
      },
      {
        title: 'CPU',
        dataIndex: 'spec.cpu.totalCores',
        render: (totalCores: number) => totalCores + t('common:cores'),
      },
      {
        title: t('common:memory'),
        dataIndex: 'spec.memory.totalMemory',
        render: (totalMemory: number) => `${totalMemory}Gi`,
      },
      {
        title: t('data-center:boot.network.static.ip'),
        dataIndex: 'spec.bootstrapNetwork.staticIpv4',
        render: (ip: string | undefined) => ip || '-',
      },
      {
        title: t('common:graphics.card'),
        dataIndex: 'spec.gpus',
        minWidth: '30%',
        render: (gpus: { model?: string; num?: number }[]) => {
          if (!Array.isArray(gpus) || !gpus.length) return '-';
          return (
            <>
              {gpus.map((item, index) => (
                <Tooltip
                  key={item?.model ? `${item.model}-${item.num}-${index}` : index}
                  position="tl"
                  content={item?.model ? `${item.model}*${item.num}` : ''}
                >
                  <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {item?.model ? `${item.model}*${item.num}` : ''}
                  </div>
                </Tooltip>
              ))}
            </>
          );
        },
      },
      {
        title: t('common:manufacturer'),
        dataIndex: 'spec.manufacturer',
      },
      {
        title: t('common:model'),
        dataIndex: 'spec.model',
      },
    ],
    [t],
  );
}
